module.exports = __webpack_public_path__ + "img/managerRelationship.ad5fade1.svg";